import { render, staticRenderFns } from "./PaginationComponent.vue?vue&type=template&id=53548ef2&scoped=true&"
import script from "./PaginationComponent.vue?vue&type=script&lang=ts&"
export * from "./PaginationComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationComponent.vue?vue&type=style&index=0&id=53548ef2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53548ef2",
  null
  
)

export default component.exports